import { sample } from "effector"
import { t } from "i18next"
import { notificationsApi } from "@callcenter/api"

import { selfServiceApi } from "../api"
import { closeUpgradeNowModal, closeVerificationModal, qrModalClosed, underReviewOpened } from "./self-service.model"

sample({
  clock: selfServiceApi.requestUpgradeFx.failData,
  target: [underReviewOpened, closeUpgradeNowModal, closeVerificationModal, qrModalClosed]
})

sample({
  clock: selfServiceApi.sendVerificationEmailFx.fail,
  fn: () => ({ text: t("component_notification_notificationLabel_somethingWentWrongLabel") }),
  target: notificationsApi.failedNotificationFx
})
